/*
Defines the custom element <ravel-circular-sequence>
*/

import { RavelCircularSequence } from './src/RavelCircularSequence.js';

customElements.define('ravel-circular-sequence', RavelCircularSequence);
